import { _ as __decorate, f as __metadata, B as BaseComponent, b as TIMELINE_HEADING_LEVELS, a as TIMELINE_ELEMENT_VARIANTS, T as TIMELINE_ELEMENT_DARK_VARIANTS } from '../types-H7O1ogf7.js';
import { css, nothing, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { unsafeStatic, html as html$1 } from 'lit/static-html.js';
import 'lit/directive.js';

var styles = css`@charset "UTF-8";
.row {
  --bsi-gutter-x: 24px;
  --bsi-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bsi-gutter-y));
  margin-right: calc(-0.5 * var(--bsi-gutter-x));
  margin-left: calc(-0.5 * var(--bsi-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bsi-gutter-x) * 0.5);
  padding-left: calc(var(--bsi-gutter-x) * 0.5);
  margin-top: var(--bsi-gutter-y);
}

.col {
  flex: 1 0 0%;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bsi-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bsi-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bsi-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bsi-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bsi-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bsi-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bsi-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bsi-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bsi-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bsi-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bsi-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bsi-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0 0%;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bsi-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bsi-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bsi-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bsi-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bsi-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bsi-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bsi-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bsi-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bsi-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bsi-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bsi-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bsi-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0 0%;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bsi-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bsi-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bsi-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bsi-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bsi-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bsi-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bsi-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bsi-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bsi-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bsi-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bsi-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bsi-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0 0%;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bsi-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bsi-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bsi-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bsi-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bsi-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bsi-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bsi-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bsi-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bsi-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bsi-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bsi-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bsi-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0 0%;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bsi-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bsi-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bsi-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bsi-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bsi-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bsi-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bsi-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bsi-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bsi-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bsi-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bsi-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bsi-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0 0%;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bsi-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bsi-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bsi-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bsi-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bsi-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bsi-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bsi-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bsi-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bsi-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bsi-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bsi-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bsi-gutter-y: 3rem;
  }
}
.row.variable-gutters {
  margin-right: -12px;
  margin-left: -12px;
}
.row.variable-gutters > .col,
.row.variable-gutters > [class*=col-] {
  padding-right: 12px;
  padding-left: 12px;
}
.row.variable-gutters {
  margin-right: -6px;
  margin-left: -6px;
}
.row.variable-gutters > .col,
.row.variable-gutters > [class*=col-] {
  padding-right: 6px;
  padding-left: 6px;
}
@media (min-width: 576px) {
  .row.variable-gutters {
    margin-right: -6px;
    margin-left: -6px;
  }
  .row.variable-gutters > .col,
  .row.variable-gutters > [class*=col-] {
    padding-right: 6px;
    padding-left: 6px;
  }
}
@media (min-width: 768px) {
  .row.variable-gutters {
    margin-right: -10px;
    margin-left: -10px;
  }
  .row.variable-gutters > .col,
  .row.variable-gutters > [class*=col-] {
    padding-right: 10px;
    padding-left: 10px;
  }
}
@media (min-width: 992px) {
  .row.variable-gutters {
    margin-right: -12px;
    margin-left: -12px;
  }
  .row.variable-gutters > .col,
  .row.variable-gutters > [class*=col-] {
    padding-right: 12px;
    padding-left: 12px;
  }
}
@media (min-width: 1200px) {
  .row.variable-gutters {
    margin-right: -12px;
    margin-left: -12px;
  }
  .row.variable-gutters > .col,
  .row.variable-gutters > [class*=col-] {
    padding-right: 12px;
    padding-left: 12px;
  }
}
@media (min-width: 1400px) {
  .row.variable-gutters {
    margin-right: -14px;
    margin-left: -14px;
  }
  .row.variable-gutters > .col,
  .row.variable-gutters > [class*=col-] {
    padding-right: 14px;
    padding-left: 14px;
  }
}

.row.row-column-border > [class^=col-] {
  padding-top: var(--bsi-spacing-l);
  padding-bottom: var(--bsi-spacing-l);
  border-top: var(--bsi-border-base) solid var(--bsi-color-border-subtle);
}
.row.row-column-border > [class^=col-]:first-child {
  border: none;
}
.row.row-column-border > [class^=col-] .navbar {
  padding: 0;
}
.row.row-column-border > [class^=col-] .navbar .menu-wrapper .nav-link {
  padding-right: 0;
}
.row.row-column-menu-left > [class^=col-]:first-child {
  padding: var(--bsi-spacing-s) 0;
}
.row.row-column-menu-right > [class^=col-]:last-child {
  padding: var(--bsi-spacing-s) 0;
}
.row.row-card {
  background-color: var(--bsi-color-background-inverse);
}
@media (min-width: 992px) {
  .row.row-column-border {
    margin-top: 1rem;
    border-top: var(--bsi-border-base) solid var(--bsi-color-border-subtle);
  }
  .row.row-column-border > [class^=col-] {
    padding: 3rem 3rem;
    border-top: none;
    border-left: var(--bsi-border-base) solid var(--bsi-color-border-subtle);
  }
  .row.row-column-border > [class^=col-]:first-child {
    border: none;
    padding-left: 0;
  }
  .row.row-column-border > [class^=col-] .navbar {
    padding: 8px 0;
  }
  .row.row-column-border > [class^=col-] .navbar .menu-wrapper {
    padding: 0;
  }
  .row.row-column-menu-left > [class^=col-]:first-child {
    padding: 0;
  }
  .row.row-column-menu-right > [class^=col-]:last-child {
    padding: 0;
  }
}
.row.row-full-width {
  max-width: 100vw;
  margin: 0 calc(-50vw + 50%);
}
.row.row-full-width > * {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.row.row-full-width > * img {
  width: 100%;
  height: 100%;
  max-height: 600px;
  object-fit: cover;
}
.row.row-title {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media (min-width: 576px) {
  .row.row-title {
    flex-direction: row;
    align-items: flex-start;
  }
}
.row.row-border h1 {
  border-bottom: var(--bsi-border-base) solid var(--bsi-color-border-subtle);
  padding-bottom: var(--bsi-spacing-s);
  margin-bottom: var(--bsi-spacing-s);
}
.row.row-border h2 {
  border-bottom: var(--bsi-border-base) solid var(--bsi-color-border-subtle);
  padding-bottom: var(--bsi-spacing-s);
  margin-bottom: var(--bsi-spacing-s);
}
.row.row-border h3 {
  border-bottom: var(--bsi-border-base) solid var(--bsi-color-border-subtle);
  padding-bottom: var(--bsi-spacing-s);
  margin-bottom: var(--bsi-spacing-s);
}
.row.row-border h4 {
  border-bottom: var(--bsi-border-base) solid var(--bsi-color-border-subtle);
  padding-bottom: var(--bsi-spacing-s);
  margin-bottom: var(--bsi-spacing-s);
}
.row.row-border h5 {
  border-bottom: var(--bsi-border-base) solid var(--bsi-color-border-subtle);
  padding-bottom: var(--bsi-spacing-s);
  margin-bottom: var(--bsi-spacing-s);
}
.row.row-border h6 {
  border-bottom: var(--bsi-border-base) solid var(--bsi-color-border-subtle);
  padding-bottom: var(--bsi-spacing-s);
  margin-bottom: var(--bsi-spacing-s);
}
@media (min-width: 576px) {
  .row.row-border {
    border-bottom: var(--bsi-border-base) solid var(--bsi-color-border-subtle);
    padding-bottom: var(--bsi-spacing-s);
    margin-bottom: var(--bsi-spacing-s);
  }
  .row.row-border h1 {
    border: none;
    margin: 0;
    padding: 0;
  }
  .row.row-border h2 {
    border: none;
    margin: 0;
    padding: 0;
  }
  .row.row-border h3 {
    border: none;
    margin: 0;
    padding: 0;
  }
  .row.row-border h4 {
    border: none;
    margin: 0;
    padding: 0;
  }
  .row.row-border h5 {
    border: none;
    margin: 0;
    padding: 0;
  }
  .row.row-border h6 {
    border: none;
    margin: 0;
    padding: 0;
  }
}
.row.row-calendar {
  display: block;
}

.sticky-wrapper.is-sticky {
  position: fixed;
}
.sticky-wrapper.is-sticky.navbar-wrapper {
  z-index: 1;
  left: 0;
  right: 0;
  width: auto;
}
.sticky-wrapper.is-sticky.navbar-wrapper .navbar {
  padding-top: var(--bsi-spacing-s);
  padding-bottom: var(--bsi-spacing-s);
  border-top: var(--bsi-border-base) solid var(--bsi-color-border-subtle);
}
.sticky-wrapper.is-sticky.navbar-wrapper.sticky-expanded {
  z-index: auto;
}
@media (min-width: 992px) {
  .sticky-wrapper.is-sticky.navbar-wrapper {
    z-index: auto;
    left: auto;
    right: auto;
    width: unset;
  }
  .sticky-wrapper.is-sticky.navbar-wrapper .navbar {
    border: none;
    background-color: transparent;
    padding: 0;
  }
  .sticky-wrapper.is-sticky.navbar-wrapper .navbar .menu-wrapper {
    padding: 0;
  }
  .sticky-wrapper.is-sticky.navbar-wrapper .navbar .menu-wrapper .nav-link {
    padding-right: 0;
  }
  .sticky-wrapper.is-sticky.navbar-wrapper .navbar.it-bottom-navscroll {
    border: none;
  }
  .sticky-wrapper.is-sticky.navbar-wrapper.at-bottom {
    position: absolute;
    top: auto !important;
    bottom: 0;
  }
}
.sticky-wrapper.navbar-wrapper .navbar.it-top-navscroll, .sticky-wrapper.navbar-wrapper .navbar.it-bottom-navscroll {
  position: relative;
  top: auto;
  left: auto;
  right: auto;
  bottom: auto;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: hsla(0, 0%, 0%, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: 1px solid;
  opacity: 0.25;
}

p {
  margin-top: 0;
  margin-bottom: var(--bsi-paragraph-spacing);
}

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: var(--bsi-spacing-s);
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: var(--bsi-spacing-l);
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: var(--bsi-spacing-s);
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: var(--bsi-font-weight-strong);
}

dd {
  margin-bottom: var(--bsi-spacing-xxs);
  margin-left: 0;
}

blockquote {
  margin: 0 0 var(--bsi-spacing-s);
}

sub,
sup {
  position: relative;
  font-size: var(--bsi-font-size-1);
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: var(--bsi-color-link);
  text-decoration: underline;
  text-decoration-skip-ink: auto;
  text-underline-offset: 2px;
}
a:hover {
  color: var(--bsi-color-link-hover);
  cursor: pointer;
}

pre,
code,
kbd,
samp {
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: var(--bsi-paragraph-spacing);
  overflow: auto;
}
pre code {
  word-break: normal;
}

a > code {
  color: inherit;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: hsl(210, 17%, 44%);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

body {
  font-family: var(--bsi-font-sans);
}

p,
ul,
ol,
dl {
  font-size: var(--bsi-body-font-size);
  line-height: var(--bsi-body-leading);
}

caption,
figcaption {
  font-size: var(--bsi-caption-font-size);
  line-height: var(--bsi-caption-leading);
}

b,
strong {
  font-weight: var(--bsi-font-weight-strong);
}

mark,
code {
  padding: 0 var(--bsi-spacing-3xs);
}

mark {
  background-color: var(--bsi-highlight-background);
}

pre,
code,
kbd,
samp {
  border-radius: var(--bsi-radius-smooth);
  font-family: var(--bsi-font-mono);
}

ins,
del {
  position: relative;
  display: flex;
  align-items: center;
  padding: var(--bsi-spacing-3xs) var(--bsi-spacing-m);
  font: var(--bsi-body-font-size);
  text-decoration: none;
}

ins {
  background-color: var(--bsi-ins-background);
  text-decoration: none;
}

del {
  background-color: var(--bsi-del-background);
}

del::before,
ins::before {
  position: absolute;
  left: 0.5rem;
}

del::before {
  content: "−";
}

ins::before {
  content: "+";
}

kbd {
  margin: 0 2px;
  padding: 2px var(--bsi-spacing-3xs);
  border: var(--bsi-border-base) solid var(--bsi-color-border-subtle);
  background-color: var(--bsi-color-background-secondary-lighter);
  box-shadow: var(--bsi-elevation-low), 0 2px 0 0 hsla(255, 0%, 100%, 0.7) inset;
  color: var(--bsi-color-text-secondary);
  font-size: var(--bsi-font-size-1);
  font-weight: var(--bsi-font-weight-solid);
  white-space: nowrap;
}
kbd kbd {
  padding: 0;
  font-size: var(--bsi-code-font-size);
}

small,
.small {
  font-size: var(--bsi-caption-font-size);
}

.x-small {
  font-size: var(--bsi-font-size-1);
}

h1,
.h1 {
  font-size: var(--bsi-heading-1-font-size);
}

h2,
.h2 {
  font-size: var(--bsi-heading-2-font-size);
}

h3,
.h3 {
  font-size: var(--bsi-heading-3-font-size);
}

h4,
.h4 {
  font-size: var(--bsi-heading-4-font-size);
}

h5,
.h5 {
  font-size: var(--bsi-heading-5-font-size);
}

h6,
.h6 {
  font-size: var(--bsi-heading-6-font-size);
}

h1,
.h1,
h2,
.h2,
h3,
.h3,
h4,
.h4,
h5,
.h5,
h6,
.h6 {
  margin-top: 0;
  margin-bottom: var(--bsi-heading-spacing);
  line-height: var(--bsi-heading-leading);
}
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h1, p + h1,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h1,
p + .h1,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h2,
p + h2,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h2,
p + .h2,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h3,
p + h3,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h3,
p + .h3,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h4,
p + h4,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h4,
p + .h4,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h5,
p + h5,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h5,
p + .h5,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h6,
p + h6,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h6,
p + .h6 {
  padding-top: var(--bsi-spacing-s);
}

h1,
h2,
h3,
.h1,
.h2,
.h3 {
  font-weight: var(--bsi-heading-font-weight);
}

h4,
h5,
h6,
.h4,
.h5,
.h6 {
  font-weight: var(--bsi-heading-font-weight-weak);
}

h1,
.h1,
.display-1 {
  letter-spacing: -1px;
}

.font-serif {
  font-family: var(--bsi-font-serif) !important;
}

.font-sans-serif {
  font-family: var(--bsi-font-sans) !important;
}

.font-monospace {
  font-family: var(--bsi-font-mono) !important;
}

.display-1 {
  font-size: var(--bsi-display-font-size);
  font-weight: var(--bsi-heading-font-weight);
  line-height: var(--bsi-heading-leading);
}

.lead {
  font-size: var(--bsi-lead-font-size);
  font-weight: var(--bsi-lead-font-weight);
  line-height: var(--bsi-lead-leading);
}

blockquote,
.blockquote {
  margin: var(--bsi-spacing-m) 0;
  margin-left: var(--bsi-spacin-inline-xs);
  padding: var(--bsi-spacing-s);
  border-left: var(--bsi-border-thick) solid var(--bsi-border-color-secondary);
  font-size: var(--bsi-body-font-size);
  line-height: var(--bsi-body-leading);
}
blockquote > :last-child,
.blockquote > :last-child {
  margin-bottom: 0;
}
blockquote.text-end,
.blockquote.text-end {
  margin-right: var(--bsi-spacin-inline-xs);
  border-right: var(--bsi-border-thick) solid var(--bsi-border-color-secondary);
}
blockquote.text-center, blockquote.text-end, blockquote.blockquote-simple,
.blockquote.text-center,
.blockquote.text-end,
.blockquote.blockquote-simple {
  margin-left: 0;
  border-right: none;
  border-left: none;
}
blockquote.text-center, blockquote.blockquote-simple,
.blockquote.text-center,
.blockquote.blockquote-simple {
  padding: 0;
}
blockquote.blockquote-simple,
.blockquote.blockquote-simple {
  font-style: italic;
}
blockquote.blockquote-card,
.blockquote.blockquote-card {
  margin-left: 0;
  padding: var(--bsi-spacing-m);
  background-color: var(--bsi-color-background-inverse);
  box-shadow: var(--bsi-elevation-low);
}
blockquote.blockquote-card .blockquote-footer,
.blockquote.blockquote-card .blockquote-footer {
  font-size: inherit;
}
blockquote.blockquote-card .blockquote-footer:before,
.blockquote.blockquote-card .blockquote-footer:before {
  content: none;
}
blockquote.blockquote-card.dark,
.blockquote.blockquote-card.dark {
  border-left: none;
  background-color: var(--bsi-color-background-primary);
  color: var(--bsi-color-text-inverse);
}
blockquote.blockquote-card.dark .blockquote-footer,
.blockquote.blockquote-card.dark .blockquote-footer {
  color: var(--bsi-color-text-inverse);
}

.blockquote-footer {
  margin-top: 0;
  margin-bottom: var(--bsi-spacing-s);
  color: var(--bsi-color-text-secondary);
  font-size: var(--bsi-label-font-size);
}
.blockquote-footer::before {
  content: "— ";
}
.bg-dark .blockquote-footer {
  color: var(--bsi-color-text-muted);
}

.initialism {
  font-size: var(--bsi-label-font-size-s);
  text-transform: uppercase;
}

*,
*::before,
*::after {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

:host {
  display: block;
}

.timeline-element {
  position: relative;
  z-index: 1;
  min-height: 80px;
  padding: 18px 18px 18px 40px;
}
@media (max-width: 991.98px) {
  .timeline-element {
    margin-top: 32px;
    margin-bottom: 30px;
  }
}

.it-pin-wrapper {
  position: absolute;
  z-index: 4;
  top: -24px;
  right: auto;
  left: calc(4px + 12px / 2);
  display: flex;
  align-items: center;
}
.it-pin-wrapper .pin-icon {
  display: flex;
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: 8px solid hsl(0, 0%, 100%);
  border-radius: 50%;
  margin-right: 16px;
  background: var(--bsi-color-white, #fff);
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);
}
.it-pin-wrapper .pin-icon svg {
  width: 24px;
  height: 24px;
  fill: var(--bsi-color-background-primary);
}
.it-pin-wrapper .pin-icon ::slotted(*) {
  width: 24px;
  height: 24px;
}
.it-pin-wrapper .pin-text {
  border-radius: 40px;
  background: var(--bsi-color-background-primary-deep);
  color: var(--bsi-color-white, #fff);
  font-family: var(--bsi-font-mono);
  font-size: var(--bsi-body-font-size);
  font-weight: 600;
  line-height: var(--bsi-body-leading);
  text-transform: uppercase;
  white-space: nowrap;
}
.it-pin-wrapper .pin-text span {
  position: relative;
  display: block;
  padding: 4px 16px;
}
.it-pin-wrapper .pin-text span::after {
  position: absolute;
  top: 50%;
  left: -4px;
  width: 10px;
  height: 10px;
  border-radius: 3px;
  background: hsl(210, 100%, 20%);
  content: "";
  transform: translateY(-50%) rotate(45deg);
}
.it-pin-wrapper.it-now .pin-icon {
  background: var(--bsi-color-background-primary);
}
.it-pin-wrapper.it-now .pin-icon svg {
  fill: var(--bsi-color-white, #fff);
}
.it-pin-wrapper.it-now .pin-text {
  background: var(--bsi-color-background-primary);
}
.it-pin-wrapper.it-now .pin-text span::after {
  background: var(--bsi-color-background-primary);
}
.it-pin-wrapper.it-evidence .pin-icon {
  background: var(--bsi-color-background-primary-deep);
}
.it-pin-wrapper.it-evidence .pin-icon svg {
  fill: var(--bsi-color-white, #fff);
}
.it-pin-wrapper.it-evidence .pin-text {
  background: var(--bsi-color-background-primary-deep);
}
.it-pin-wrapper.it-evidence .pin-text span::after {
  background: var(--bsi-color-background-primary-deep);
}

::slotted(*) {
  display: block;
}

::slotted(it-card) {
  margin-top: 16px;
  margin-bottom: 16px;
}

@media (max-width: 991.98px) {
  ::slotted(it-card) {
    margin-top: 36px;
    margin-bottom: 0px;
    margin-left: -22px;
  }
}
@media (min-width: 992px) {
  .timeline-element {
    padding: var(--it-timeline-content-padding, 18px 18px 18px 40px);
  }
  .it-pin-wrapper {
    right: var(--it-timeline-pin-right, auto);
    left: var(--it-timeline-pin-left, calc(12px / 2));
    flex-direction: var(--it-timeline-pin-direction, row);
  }
  .it-pin-wrapper .pin-icon {
    margin-right: var(--it-timeline-pin-icon-mr, 16px);
    margin-left: var(--it-timeline-pin-icon-ml, 0);
  }
  .it-pin-wrapper .pin-text {
    font-size: 1rem;
  }
  .it-pin-wrapper .pin-text span::after {
    right: var(--it-timeline-pin-arrow-right, auto);
    left: var(--it-timeline-pin-arrow-left, -4px);
  }
}
.it-now-label {
  position: absolute;
  z-index: 5;
  top: calc(50% - 16px);
  right: var(--it-timeline-now-label-right);
  left: var(--it-timeline-now-label-left);
  display: flex;
  flex-direction: var(--it-timeline-pin-direction, row);
  align-items: center;
  color: var(--bsi-color-background-primary);
  font-family: var(--bsi-font-mono);
  font-weight: 600;
  gap: 16px;
}
@media (max-width: 991.98px) {
  .it-now-label {
    display: none;
  }
}
.it-now-label::after {
  width: 16px;
  height: 1px;
  background-color: var(--bsi-color-background-primary);
  content: "";
}`;

/** Mappa da nome API semantico → classe CSS BSI per il pin wrapper. */
const BSI_VARIANT_CLASS = {
    current: 'it-now',
    past: 'it-evidence',
};
/**
 * Singolo elemento della timeline classica di Bootstrap Italia.
 *
 * Usa **shadow DOM** con slot reali: l'utente mette il contenuto
 * direttamente come figli senza classi aggiuntive.
 *
 * @slot pin-icon - Icona del pin (es. `<it-icon>`). Se omessa viene mostrata un'icona segnaposto.
 * @slot - Contenuto dell'elemento (es. `<it-card>`).
 *
 * @attr {string} variant - Variante colore del pin: `''` (futuro), `current` (presente, azzurro), `past` (passato, blu scuro).
 * @attr {string} date - Etichetta testuale del periodo (es. `MAGGIO 2026`).
 * @attr {string} heading-level - Livello heading (`h2`–`h6`). Default: `h3`.
 *
 * @example
 * ```html
 * <it-timeline-element variant="past" date="MAGGIO 2026">
 *   <it-icon slot="pin-icon" name="it-file" aria-hidden="true"></it-icon>
 *   <it-card>
 *     <a slot="title" href="#">Titolo del contenuto</a>
 *     <span slot="text">Descrizione breve.</span>
 *   </it-card>
 * </it-timeline-element>
 * ```
 */
let ItTimelineElement = class ItTimelineElement extends BaseComponent {
    constructor() {
        super(...arguments);
        this.variant = '';
        this.date = '';
        this.headingLevel = 'h3';
    }
    getHeadingLevel() {
        return TIMELINE_HEADING_LEVELS.includes(this.headingLevel) ? this.headingLevel : 'h3';
    }
    getVariant() {
        return TIMELINE_ELEMENT_VARIANTS.includes(this.variant) ? this.variant : '';
    }
    render() {
        if (this.variant && !TIMELINE_ELEMENT_VARIANTS.includes(this.variant)) {
            this.logger.warn(`Invalid variant value, falling back to default. Expected one of: ${TIMELINE_ELEMENT_VARIANTS.join(', ')}`);
        }
        if (this.headingLevel && !TIMELINE_HEADING_LEVELS.includes(this.headingLevel)) {
            this.logger.warn(`Invalid heading-level value, falling back to default. Expected one of: ${TIMELINE_HEADING_LEVELS.join(', ')}`);
        }
        const headingTag = unsafeStatic(this.getHeadingLevel());
        const bsiVariantClass = BSI_VARIANT_CLASS[this.getVariant()] ?? undefined;
        const pinWrapperClasses = this.composeClass('it-pin-wrapper', bsiVariantClass);
        const variant = this.getVariant();
        // Decide whether the slotted icon needs white color (dark-background variants)
        const needsInverseIcon = TIMELINE_ELEMENT_DARK_VARIANTS.includes(this.getVariant());
        return html$1 `
      <div class="col-12">
        <div class="timeline-element">
        ${variant === 'current'
            ? html `<span class="it-now-label">Oggi</span>` // <-- SOSTITUISCI CON IL TUO METODO/CHIAVE i18n E.g. this.t('today') o msg('Oggi')
            : nothing}
          <${headingTag} class="${pinWrapperClasses}">
            <div class="pin-icon">
              <slot
                name="pin-icon"
                @slotchange=${(e) => this._onPinIconSlotChange(e, needsInverseIcon)}
              >
              </slot>
            </div>
            ${this.date ? html `<div class="pin-text"><span>${this.date}</span></div>` : nothing}
          </${headingTag}>
          <slot></slot>
        </div>
      </div>
    `;
    }
    /**
     * When the pin-icon slot changes, auto-set `color="white"` on any `<it-icon>`
     * that doesn't already have an explicit color attribute.
     */
    _onPinIconSlotChange(e, needsInverse) {
        const slot = e.target;
        for (const node of slot.assignedElements()) {
            if (node.tagName.toLowerCase() === 'it-icon') {
                node.setAttribute('size', 'sm');
                if (!node.hasAttribute('color')) {
                    if (needsInverse)
                        node.setAttribute('color', 'white');
                    else
                        node.removeAttribute('color');
                }
            }
        }
    }
};
ItTimelineElement.styles = styles;
__decorate([
    property({ type: String }),
    __metadata("design:type", String)
], ItTimelineElement.prototype, "variant", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], ItTimelineElement.prototype, "date", void 0);
__decorate([
    property({ type: String, attribute: 'heading-level' }),
    __metadata("design:type", String)
], ItTimelineElement.prototype, "headingLevel", void 0);
ItTimelineElement = __decorate([
    customElement('it-timeline-element')
], ItTimelineElement);

export { ItTimelineElement };
//# sourceMappingURL=it-timeline-element.js.map
